/**
 * checkValidEmail
 *
 * @source https://stackoverflow.com/a/46181
 * @param {String} email
 */

import { validEmailRegex } from './validEmailRegex'

const checkValidEmail = (email) => {
  if (validEmailRegex.test(String(email).toLowerCase())) {
    return true
  }
  return false
}

export { checkValidEmail }
